import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=1aaa6248&scoped=true&"
import script from "./uploadData.vue?vue&type=script&lang=js&"
export * from "./uploadData.vue?vue&type=script&lang=js&"
import style0 from "./uploadData.vue?vue&type=style&index=0&id=1aaa6248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa6248",
  null
  
)

export default component.exports